import { COLORS } from 'constants/index';

export default {
    root: {
        width: 46,
        height: 46,
        border: '2px solid ' + COLORS.transparentLight
    }
};
